module.exports = __webpack_public_path__ + "img/carTopView@3x.68e8dc64.png";